'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormStubText = function FormStubText(_ref) {
    var stubText = _ref.stubText;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'stub-text' },
            stubText
        )
    );
};
FormStubText.propTypes = {
    stubText: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
};

exports.default = (0, _pacomo.pacomoTransformer)(FormStubText);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormStubText.js
// module id = 308
// module chunks = 0